"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function createFilter(sanitizedInputValue) {
    return (item) => lodash_1.includes(lodash_1.toLower(item.label), sanitizedInputValue);
}
function filterItems(inputValue, groups) {
    const sanitizedInputValue = lodash_1.toLower(lodash_1.trim(inputValue || ''));
    if (lodash_1.isEmpty(sanitizedInputValue)) {
        return groups;
    }
    return lodash_1.map(groups, group => {
        return Object.assign(Object.assign({}, group), { items: lodash_1.filter(group.items, createFilter(sanitizedInputValue)) });
    }).filter(group => !lodash_1.isEmpty(group.items));
}
exports.default = filterItems;
